import { IQuery } from "lucy/query-builder";
import { IWDDesignModeProps } from "../common";
import { IContextProvider } from "../../../uxp";
import { generateUUID, hasValue, parseValue, tryParseJSON } from "../../../util";
import * as jsonpath from "jsonpath";
import { useContext } from "react";
import React from "react";
import { IContextData } from "../../../hooks/useContextData";
import _ from 'lodash'

export const DEFAULT_ICON = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Mi4zMiA0Mi4zMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM3MjViN2E7fS5jbHMtMntmaWxsOiNlYmQxNzc7fS5jbHMtM3tmaWxsOiMwNTA1MDU7fS5jbHMtMywuY2xzLTQsLmNscy01LC5jbHMtNntzdHJva2U6IzcyNWI3YTtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9LmNscy0zLC5jbHMtNCwuY2xzLTZ7c3Ryb2tlLXdpZHRoOjAuNXB4O30uY2xzLTR7ZmlsbDojY2ViMTVmO30uY2xzLTUsLmNscy02e2ZpbGw6bm9uZTtzdHJva2UtbGluZWNhcDpyb3VuZDtvcGFjaXR5OjAuODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkFzc2V0IDM5PC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMjEuMTYiIGN5PSIyMS4xNiIgcj0iMjEuMTYiLz48cmVjdCBjbGFzcz0iY2xzLTIiIHg9IjEyLjEiIHk9IjExLjc4IiB3aWR0aD0iMTguMTIiIGhlaWdodD0iMTguMTIiIHJ4PSIzIiByeT0iMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4zMiA0Mikgcm90YXRlKC05MCkiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMyIgY3g9IjEyLjEiIGN5PSIyNC41MSIgcj0iMS42MiIvPjxjaXJjbGUgY2xhc3M9ImNscy00IiBjeD0iMzAuMjIiIGN5PSIxNy44MSIgcj0iMS42MiIvPjxjaXJjbGUgY2xhc3M9ImNscy00IiBjeD0iMzAuMjIiIGN5PSIyNC41MSIgcj0iMS42MiIvPjxsaW5lIGNsYXNzPSJjbHMtNSIgeDE9IjE1LjY5IiB5MT0iMTYuMDEiIHgyPSIyNC43NSIgeTI9IjE2LjAxIi8+PGxpbmUgY2xhc3M9ImNscy02IiB4MT0iMTUuNjkiIHkxPSIxOC4wNiIgeDI9IjI0Ljc1IiB5Mj0iMTguMDYiLz48bGluZSBjbGFzcz0iY2xzLTYiIHgxPSIxNS42OSIgeTE9IjI2LjMxIiB4Mj0iMjMuNDQiIHkyPSIyNi4zMSIvPjxsaW5lIGNsYXNzPSJjbHMtNiIgeDE9IjE1LjY5IiB5MT0iMjQuOTYiIHgyPSIyNS43NSIgeTI9IjI0Ljk2Ii8+PC9nPjwvZz48L3N2Zz4=';

/* safe default schema */
const DEFAULT_SCHEMA: any = { type: 'array', items: { type: 'object', properties: {}, required: [] } };
/*
The data structures that a widget can accept:
value - a single value
dictionary - multiple key/value pairs
value-array - an array of single values [1,2,3]
dictionary-array - an array of dictionaries
any - uh, any schema
*/
export declare type TargetDataStructure = 'value' | 'dictionary' | 'value-array' | 'dictionary-array' | 'any';

export interface ITargetDataStructureOptions {
    preferredFields?: string[];
}

export type IDataSource = IModelActionDataSource | IModelCollectionDataSource | ICustomJsonDataSource | IExternalDatabaseDataSource | IQueryDataSource;

export interface IDataSourceBinding {
    source: string;
    path: string;
}


export interface IDataSourceBase {
    id: string; // source id
    description: string // source description
    parameters: IDataSourceParameter[] // params to pass to datasource 
    schema?: any; // output schema
    icon?: string

    enableCache?: boolean;
    cacheRefreshInterval?: number; // this is in minutes

    __source__?: any // ICollection | IModelAction; // actual source ::TODO - create new interfaces 
}

export interface IDataSourceParameter {
    type: string;
    id: string;
    description: string;
    example: string;
    value: string;
}

export interface IModelActionDataSource extends IDataSourceBase {
    type: 'model-action';
    model: string;
    action: string;
}

export interface IModelCollectionDataSource extends IDataSourceBase {
    type: 'model-collection';
    model: string;
    modelKey: string,
    action: string;
    grouping?: any[];
    filter?: any;
}

export interface ICustomJsonDataSource extends IDataSourceBase {
    type: 'custom-json';
    json: any; // custom json
    name: string
}

export interface IExternalDatabaseDataSource extends IDataSourceBase {
    type: 'external-database';
    model: string,
    action: string
    modelKey: string;
    databaseId: string;
    grouping?: any[];
    filter?: any;
}

export interface IQueryDataSource extends IDataSourceBase {
    type: 'query';
    query: IQuery;
    name: string
}




export interface IModelAction {
    Name: string;
    Action: string;
    Icon: string;
    MapKey: string;
    OutputSchema: string;
    Definition: string;
    Docs: string;
    Filter?: any[];
    Grouping?: any[];
    Inputs?: { name: string, value: string, description: string, example: string, dataType: string }[];
    SelectedPath?: string;
}

// this will be used for collections and external databases
export interface ICollection {
    Name: string;
    Action: string;
    Type: string;
    MapKey: string;
    Attributes: any;
    Docs: string;
    Description: string;
    Grouping?: any[];
    OutputSchema?: any;
    Filter?: any[];
    Inputs?: { name: string, value: string, description: string, example: string, dataType: string }[];
    SelectedPath?: string;
    ID?: string
}

export function isModelCollection(t: ICollection | IModelAction): t is ICollection {
    return (t as any)?.Type == 'collection';
}
export function isExternalDatabase(t: ICollection | IModelAction): t is ICollection {
    return (t as any)?.Type == 'external';
}


function isScalar(t: string) {
    return t == 'string' || t == 'number' || t == 'integer';
}

function deriveJSONPathForValue(schema: any, options: ITargetDataStructureOptions, existingPath: string = ''): string {
    switch (schema.type) {
        case 'string':
        case 'number':
        case 'integer':
            return existingPath;
        case 'array':
            let items = schema.items;
            if (items instanceof Array) {
                throw 'Array invalid type structure';
            }
            if (typeof items == 'object') {
                let subSchema = items;
                return deriveJSONPathForValue(subSchema, options, existingPath + '.[0]');
            }
            throw 'Array contains unknown items element:' + JSON.stringify(items);
        case 'object':
            let props = schema.properties;
            let propNames = Object.keys(props);
            if (propNames.length == 0) throw 'Object with no properties:' + JSON.stringify(schema);
            let PROPNAMES = propNames.map(x => x.toUpperCase());
            let PREFERREDNAMES = options?.preferredFields?.map(x => x.toUpperCase());
            for (let pn in PREFERREDNAMES) {
                let pi = PROPNAMES.indexOf(pn);
                if (pi < 0) continue;
                let propName = propNames[pi];
                if (isScalar(props[propName].type)) {
                    return existingPath + '.' + propName;
                }
            }
            let firstProp = propNames.find(x => isScalar(props[x].type));
            if (firstProp) {
                return existingPath + '.' + firstProp;
            }

            let firstArrayProp = propNames.find(x => props[x].type == 'array');
            return deriveJSONPathForValue(props[firstArrayProp], options, existingPath + '.' + firstArrayProp);
    }
    throw 'Should not be here';

}

function deriveJSONPathForDictionary(schema: any, options: ITargetDataStructureOptions, existingPath: string = '') {
    if (schema.type == 'object') {
        return existingPath;
    }
    if (schema.type == 'array') {
        let items = schema.items;
        if (items instanceof Array) {
            throw 'Nested arrays found:' + JSON.stringify(schema);
        }

        return existingPath + '.[0]';
    }
    throw 'No dictionary found: ' + JSON.stringify(schema);

}

function deriveJSONPathForDictionaryArray(schema: any, options: ITargetDataStructureOptions, existingPath: string): string {
    if (schema.type == 'object') {
        let props = schema.properties;
        for (let k in props) {
            let v = props[k];
            if (v.type == 'array') {
                return deriveJSONPathForDictionaryArray(v, options, existingPath + '.' + k);
            }
        }
        throw 'No array found in dictionary:' + JSON.stringify(schema);
    }
    if (schema.type == 'array') {
        let items = schema.items;
        if (items instanceof Array) {
            throw 'Nested array list found:' + JSON.stringify(schema);
        }
        if (items.type == 'object') {
            return existingPath;
        }
    }
    throw 'Unable to find json path for dict array:' + JSON.stringify(schema);
}

export function deriveJSONPath(schema: any, options: ITargetDataStructureOptions, target: TargetDataStructure) {
    switch (target) {
        case 'value': return deriveJSONPathForValue(schema, options, '$');
        case 'dictionary': return deriveJSONPathForDictionary(schema, options, '$');
        case 'dictionary-array': return deriveJSONPathForDictionaryArray(schema, options, '$');
        case 'any':
        case null:
            try {
                return deriveJSONPathForDictionaryArray(schema, options, '$');
            } catch (e) {
                console.log('Error extracting dict array schema');
            }
            try {
                return deriveJSONPathForDictionary(schema, options, '$');
            } catch (e) {
                console.log('Error extracting dict schema');
            }
            try {
                return deriveJSONPathForValue(schema, options, '$');
            } catch (e) {
                console.log('Error extracting value schema');
            }
            throw 'Unable to match "any" schema';
    }
}

export function validateSchema(schema: any, target: TargetDataStructure) {
    switch (target) {
        case "dictionary": return schema.type == 'object';
        case 'dictionary-array': return (schema.type == 'array') && (schema.items?.type == 'object');
        case "value": return ['string', 'number', 'integer'].indexOf(schema.type) >= 0;
        case 'any': return true;
        case null: return true
    }
    return false;
}

export function schemaAtJsonPath(schema: any, path: string): any {
    if (!schema) {
        return schema;
    }
    if (!hasValue(path)) return schema;

    let [first, ..._rest] = path.split('.');
    let rest = _rest.join('.');
    if (first == '$') {
        return schemaAtJsonPath(schema, rest);
    }
    let indexMatches = first.match(/\[(\d+)\]/);
    if (indexMatches) {
        let index = Number(indexMatches[1]);
        if (schema.type != 'array') {
            throw 'Expected array in schema: ' + JSON.stringify(schema) + ":" + path;
        }
        //TODO: what to do with items is empty?
        let items = schema.items || { type: "object", "properties": {} };

        if (items.type == 'array') {
            throw 'Unexpected array structure in schema: ' + JSON.stringify(schema);
        }
        return schemaAtJsonPath(items, rest);

    }
    if (schema.type != 'object') {
        throw 'Expected object in schema: ' + JSON.stringify(schema) + ":" + path;
    }
    if (!schema?.properties?.[first]) {
        throw 'Unable to find key ' + first + ' in object ' + JSON.stringify(schema);
    }
    return schemaAtJsonPath(schema.properties[first], rest);

}

export function combinePaths(path: string, ...rest: string[]) {
    let finalPath = path;
    for (let p of rest) {
        if (!!p) {
            finalPath = finalPath + '.' + p.replace(/^\$\.?/, '');
            if (finalPath.endsWith('.')) {
                finalPath = finalPath.slice(0, -1);
            }
        }
    }
    return finalPath;
}



export function registerDataSource(ds: IDataSource, id?: string) {
    if (!hasValue(id)) id = generateUUID();
    return Object.assign({}, ds, { id });
}

export function findDataSource(id: string, sources: IDataSource[]) {
    if (!sources) return null;
    return sources.find(x => x.id == id);
}

export function dataSourceLabel(ds: IDataSource) {
    console.log('dataspirce ', ds);

    if (ds.type == 'model-action') return `${ds.model}.${ds.action}`;
    if (ds.type == 'custom-json') return (ds as ICustomJsonDataSource).name || ''
    if (ds.type == 'model-collection') return `collection:${ds.model}.${ds.action}`
}

export function getDependencyParameters(bindings: IDataSourceBinding[], sources: IDataSource[], contextData: any) {

    let deps: any[] = [];
    if (!bindings) {
        return deps;
    }
    for (let binding of bindings) {
        if (!binding) {
            continue;
        }
        let ds = findDataSource(binding.source, sources);
        if (!ds) {
            continue;
        }
        let sourceParameters = ds.parameters;
        for (let p of sourceParameters) {
            let v = parseValue(p.value, contextData);
            deps.push(v);
        }
    }
    return deps;
}

export function findAvailableFields(binding: IDataSourceBinding, sources: IDataSource[]) {
    let results: any = {};
    let t = binding;
    let source = sources?.find(x => x.id == t?.source);
    if (source) {
        let path = binding?.path;

        let targetSchema = (schemaAtJsonPath(source.schema, path));
        if (targetSchema?.type == 'array') {
            if (targetSchema.items?.type == 'object') {
                let required = Object.keys(targetSchema.items?.properties || {});
                for (let r of required) {
                    results[r] = '1';
                }
            }
        }

    }
    let pv = Object.keys(results);
    pv.sort();
    return pv;

};


function parseToArray(value: any): any[] {
    if (Array.isArray(value)) {
        return value;
    }
    if (typeof value === 'string') {
        try {
            const parsedArray = JSON.parse(value);
            if (Array.isArray(parsedArray)) {
                return parsedArray;
            }
        } catch (e) {
            // Not a JSON stringified array
        }
        return value.split(',').map(item => item.trim());
    }
    return [];
}

function recursivelyParseConditions(condition: any, data: any): any {
    if (Array.isArray(condition)) {
        return condition.map(c => recursivelyParseConditions(c, data));
    } else if (typeof condition === 'object' && condition !== null) {
        const parsedCondition: any = {};
        for (const key in condition) {
            if (condition.hasOwnProperty(key)) {
                if (typeof condition[key] === 'object' && condition[key] !== null) {
                    parsedCondition[key] = recursivelyParseConditions(condition[key], data);
                } else {
                    let parsedValue = parseValue(condition[key], data);
                    if (key === '$in') {
                        parsedValue = parseToArray(parsedValue);
                    }
                    parsedCondition[key] = parsedValue;
                }
            }
        }
        return parsedCondition;
    } else {
        return parseValue(condition, data);
    }
}

function interpolateFilters(filter: any, data: any) {
    if (!filter) return filter;
    if (!data) return filter;
    try {
        const parsedFilters = recursivelyParseConditions(filter, data)
        return parsedFilters
    } catch (e) {
        console.log('Error interpolating filter', filter, data, e);
        return filter;
    }
}


function parseQuery(query: IQuery, contextData: IContextData): IQuery {
    if (!query) return { sources: [], steps: [] }
    if (!contextData) return query

    const parsedSources = (query?.sources || []).map(s => {
        const params = (s?.params || []).map(p => {
            p.value = parseValue(p?.value, contextData);
            return p;
        })
        s.params = params;
        return s;
    })
    const parsedSteps = recursivelyParseConditions(query.steps, contextData)

    query.sources = parsedSources;
    query.steps = parsedSteps;

    return query
}

interface IExecuteSettings {
    disableParseParameters?: boolean
}
export async function executeAndBind(context: IContextProvider, source: IDataSourceBinding, sources: IDataSource[], parameters: any, contextData?: any, settings: IExecuteSettings = {}) {
    let ds = findDataSource(source?.source, sources);
    if (!ds) throw 'Unable to find data source: ' + source?.source;

    let result: any = null

    if (ds.type == 'custom-json') result = ds.json || {}

    else if (ds.type == 'model-action') {
        if (!settings?.disableParseParameters) {
            let sourceParameters = ds.parameters;
            for (let p of sourceParameters) {
                parameters[p.id] = parseValue(p.value, contextData || {});
            }
        }

        result = await context.executeAction(ds.model, ds.action, parameters, { json: true });
    }
    else if (ds.type === 'model-collection') {
        // check if we have filters 
        const hasFiltering = (ds.filter && Object.keys(ds.filter).length > 0)
        const hasGrouping = (ds.grouping && ds.grouping.length > 0)

        let filter = {};
        if (hasFiltering) {
            filter = interpolateFilters(ds.filter, contextData);
        }
        let service = 'Aggregate'
        parameters['model'] = ds.modelKey
        parameters['collectionName'] = ds.action

        if (hasGrouping) {
            let groups = ds.grouping || []
            groups = groups.filter(g => !('$match' in g))
            if (hasFiltering) {
                groups.unshift({ "$match": filter })
            }
            parameters['stages'] = JSON.stringify(groups)
            service = 'Aggregate'
        }
        else {
            // just filtering 
            if (parameters.hasOwnProperty('last') && parameters['last'] == null) {
                parameters['last'] = '0'
            }
            parameters['filter'] = JSON.stringify(filter || {})
            service = 'GetPaginatedDocs'
        }

        result = await context.executeService('Lucy', service, parameters, { json: true })
        result = tryParseJSON(result[0].data)
    }
    else if (ds.type === 'external-database') {
        const DBService = 'ExternalDatabase'
        const hasGrouping = (ds.grouping && ds.grouping.length > 0)
        let filter = interpolateFilters(ds?.filter || {}, contextData);
        let route = `/v1/database/${ds.databaseId}/data`
        parameters['filters'] = JSON.stringify(filter || {})
        if (parameters.hasOwnProperty('last') && parameters['last'] == null) {
            parameters['last'] = '0'
        }

        if (hasGrouping) {
            parameters['stages'] = JSON.stringify(ds.grouping || [])
            route = `/v1/database/${ds.databaseId}/aggregate`
        }
        result = await context.executeComponent(DBService, route, 'get', parameters,)
    }
    else if (ds.type === 'query') {
        const QueryEngineService = 'QueryEngine'
        const route = `/v1/execution`

        const parsedQuery = parseQuery(_.cloneDeep(ds?.query || { sources: [], steps: [] }), contextData)
        const response = await context.executeComponent(QueryEngineService, route, 'post', {}, parsedQuery)
        result = response.result
    }
    let path = source.path || '';
    if (!path || path == '$') {
        return result;
    }
    //Total utter hack because jsonpath can't handle .[x]
    var pathEx = path.replace(/\.\[/g, '[');
    let results = (jsonpath as any).default.query(result, pathEx, 1);
    return results?.[0] || null;
}

export function getSchemaFromFields(fields: { name: string, type: string }[]) {

    const properties: any = {}
    for (const f of fields) {
        properties[f.name] = { type: f.type }
    }

    return {
        type: 'array',
        items: {
            type: 'object',
            properties: properties,
            required: Object.keys(properties)
        }
    }

}

export function extractSchemaFromInitialSource(source: ICollection | IModelAction) {

    let schema: any = null
    if (!!source.OutputSchema) schema = tryParseJSON(source.OutputSchema)

    if (!schema) {
        // if schem not found 
        // generate from colllection 
        if (isModelCollection(source) || isExternalDatabase(source)) {
            // if there aggregation schema should have set, skipping that for now 
            // set the schema 

            const attributes = ((source as ICollection).Attributes || []).map((a: any) => ({ name: a.name, type: a.dataType }))
            schema = getSchemaFromFields(attributes)

        }
        else {
            // generate from action
            // skip for now
        }
    }
    return schema
}

export interface ModelDefinition {
    Definition: string,
    OutputSchema: string,
    Name: string,
    Icon: string,
    Action: string,
    Docs: string,
}

export interface IDataSourceBase {
    id: string; // source id
    description: string // source description
    parameters: IDataSourceParameter[] // params to pass to datasource 
    schema?: any; // output schema
    icon?: string

    enableCache?: boolean;
    cacheRefreshInterval?: number; // this is in minutes

    __source__?: any // ICollection | IModelAction; // actual source ::TODO - create new interfaces 
}

export function createDataSourceFromAction(x: ModelDefinition, inputs?: any[]): IDataSource {
    const actionDefinition = x ? tryParseJSON(x.Definition, null) : null
    if (!actionDefinition) return null

    const params: IDataSourceParameter[] = (actionDefinition?.parameters || []).map((x: string) => {
        let value = ''
        if (!!inputs) {
            const inst = inputs.find((i: any) => i.name === x)
            if (inst) value = inst.value
        }
        return { id: x, description: x, value: value, type: '', example: '' }
    })

    return {
        id: null,
        model: x.Name,
        action: x.Action,
        parameters: params,
        description: x.Docs,
        schema: tryParseJSON(x.OutputSchema, DEFAULT_SCHEMA),
        type: 'model-action',
        icon: x.Icon || DEFAULT_ICON
    }
}

async function processToModelAction(uxpContext: IContextProvider, uiProps: any, initSource: IModelAction, target: TargetDataStructure, datasources: IDataSource[], existingDSId?: string) {
    const { Name, Action, Inputs } = initSource

    const response = await uxpContext.executeService('UXP', 'WidgetTemplate:GetModelSource', { model: Name, action: Action }, { json: true });

    const _source = createDataSourceFromAction(response[0], Inputs)
    _source.__source__ = initSource

    // use an existing path if provided
    let bindingPath = initSource?.SelectedPath || deriveJSONPath(_source.schema, null, target);

    //If the exact schema did not match, try and find out
    if (!validateSchema(schemaAtJsonPath(_source.schema, bindingPath), target)) {
        if (!initSource?.SelectedPath) {
            throw 'Schema at given path does not match target: ' + bindingPath + ':' + target;
        }

        let innerPath = deriveJSONPath(schemaAtJsonPath(_source.schema, bindingPath), null, target);
        bindingPath = combinePaths(initSource?.SelectedPath, innerPath);
        if (!validateSchema(schemaAtJsonPath(_source.schema, bindingPath), target)) {
            throw 'Could not match schema to expected target';
        }
    }

    const source = registerDataSource(_source, existingDSId);
    const binding: IDataSourceBinding = {
        path: bindingPath,
        source: source.id,
    };
    const newSources = (datasources || []).slice().filter(s => s.id !== source.id);
    newSources.push(source);

    const title = { text: `${Name} - ${Action}` };
    return Object.assign({}, uiProps, { datasources: newSources, source: binding, title });
}

async function processToExternalDB(uiProps: any, initSource: ICollection, target: TargetDataStructure, datasources: IDataSource[], existingDSId?: string) {
    const _source: IExternalDatabaseDataSource = {
        id: null,
        model: initSource.Name,
        action: initSource.Action,
        modelKey: initSource.MapKey,
        databaseId: initSource.ID,
        parameters: initSource.Attributes.map((a: any) => ({ id: a.name, description: a.name, value: '' })),
        description: initSource.Description,
        schema: extractSchemaFromInitialSource(initSource) || DEFAULT_SCHEMA,
        type: 'external-database',
        grouping: initSource.Grouping,
        filter: initSource.Filter,
        __source__: initSource,
        icon: DEFAULT_ICON,
    }

    const bindingPath = deriveJSONPath(_source.schema, null, target);
    const source = registerDataSource(_source, existingDSId);

    const binding: IDataSourceBinding = {
        path: bindingPath,
        source: source.id,
    };

    const newSources = (datasources || []).slice().filter(s => s.id !== source.id);
    newSources.push(source);
    return Object.assign({}, uiProps, { datasources: newSources, source: binding });
}

async function processToModelCollection(uiProps: any, initSource: ICollection, target: TargetDataStructure, datasources: IDataSource[], existingDSId?: string) {
    const _source: IModelCollectionDataSource = {
        id: null,
        model: initSource.Name,
        modelKey: initSource.MapKey,
        action: initSource.Action,
        parameters: initSource.Attributes.map((a: any) => ({ id: a.name, description: a.name, value: '' })),
        description: initSource.Description,
        schema: extractSchemaFromInitialSource(initSource) || DEFAULT_SCHEMA,
        type: 'model-collection',
        grouping: initSource.Grouping,
        filter: initSource.Filter,
        __source__: initSource,
        icon: DEFAULT_ICON,
    }

    const bindingPath = deriveJSONPath(_source.schema, null, target);
    const source = registerDataSource(_source, existingDSId);

    const binding: IDataSourceBinding = {
        path: bindingPath,
        source: source.id,
    };

    const newSources = (datasources || []).slice().filter(s => s.id !== source.id);
    newSources.push(source);
    return Object.assign({}, uiProps, { datasources: newSources, source: binding });
}

async function processToQuery(uiProps: any, initSource: IQueryDataSource, target: TargetDataStructure, datasources: IDataSource[], existingDSId?: string) {
    console.log('initial_sou', initSource)
    const _source: IQueryDataSource = {
        id: null,
        description: initSource.description,
        parameters: [],
        query: initSource.query,
        name: initSource.name,
        type: 'query',
        schema: initSource.schema,
        __source__: {
            name: initSource.name,
            query: initSource.query,
            description: initSource.description,
            schema: initSource.schema
        }
    }

    const bindingPath = deriveJSONPath(_source.schema, null, target);
    const source = registerDataSource(_source, existingDSId);

    const binding: IDataSourceBinding = {
        path: bindingPath,
        source: source.id,
    };

    const newSources = (datasources || []).slice().filter(s => s.id !== source.id);
    newSources.push(source);
    return Object.assign({}, uiProps, { datasources: newSources, source: binding });
}


// this is to process the sources comming from outside (EX: canvas))
// Assume for now we will only get ModelActions. ModelCollections and ExternalDatabases 
export async function processSource(designer: IWDDesignModeProps, uxpContext: IContextProvider, uiProps: any, initSource: any, target: TargetDataStructure, datasources: IDataSource[], existingDSId?: string) {
    if (designer?.mode != 'preview') return null;
    if (!initSource) return null;

    // get source details 
    let _datasources = [...(datasources || [])]
    if (!_datasources || _datasources.length == 0) _datasources = uiProps?.datasources || []

    // now we will get Query also as a initial source - this will fully parsed as a source 
    if (initSource.hasOwnProperty('type') && initSource.type == 'query') return processToQuery(uiProps, initSource, target, datasources, existingDSId)

    if (isModelCollection(initSource)) return processToModelCollection(uiProps, initSource, target, datasources, existingDSId)
    if (isExternalDatabase(initSource)) return processToExternalDB(uiProps, initSource, target, datasources, existingDSId)
    else return processToModelAction(uxpContext, uiProps, initSource, target, datasources, existingDSId)
}


export async function processInitialSource(designer: IWDDesignModeProps, uxpContext: IContextProvider, uiProps: any, initialSource: string, target: TargetDataStructure) {
    if (designer?.mode != 'preview') return null;
    if (!initialSource) return null;

    // get source details 
    let initSource = tryParseJSON(initialSource);

    try {
        return processSource(designer, uxpContext, uiProps, initSource, target, []);
    } catch (e) {
        console.log('Unable to process the initial source ', e);
    }
}



/// TODO : REMOVE 

export type DataSourceContextProps = {
    widgetData: any;
    setWidgetData: (data: any) => void;
}

export const DataSourceContext = React.createContext<DataSourceContextProps | undefined>(undefined);

export function useDataSourceContext() {
    return useContext(DataSourceContext)
}